/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const MLDashboard: React.FC<Props> = ({ color = '#000000', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M6.22209 4.60056C6.66665 4.30351 7.13344 4.04587 7.6171 3.82927C8.98898 3.2149 9.67491 2.90771 10.5875 3.49891C11.5 4.09012 11.5 5.05992 11.5 6.99952V8.49952C11.5 10.3851 11.5 11.3279 12.0858 11.9137C12.6716 12.4995 13.6144 12.4995 15.5 12.4995H17C18.9396 12.4995 19.9094 12.4995 20.5006 13.4121C21.0918 14.3246 20.7846 15.0105 20.1702 16.3824C19.9536 16.8661 19.696 17.3329 19.399 17.7774C18.3551 19.3397 16.8714 20.5573 15.1355 21.2764C13.3996 21.9954 11.4895 22.1835 9.64665 21.817C7.80383 21.4504 6.11109 20.5456 4.78249 19.217C3.45389 17.8884 2.5491 16.1957 2.18254 14.3529C1.81598 12.5101 2.00412 10.5999 2.72315 8.86402C3.44218 7.12813 4.65982 5.64443 6.22209 4.60056Z"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
      <path
        d="M21.446 7.06901C20.6342 5.00831 18.9917 3.36579 16.931 2.55398C15.3895 1.94669 14 3.34316 14 5.00002V9.00002C14 9.5523 14.4477 10 15 10H19C20.6569 10 22.0533 8.61055 21.446 7.06901Z"
        stroke={props.style?.color || color}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export default MLDashboard;
